<template>
  <div class="scroll1">
    <div class="scroll-text-container1 w">
      <div class="mr-3 pl-3 flex items-center" style="position: absolute; z-index: 2;background: #f2f2f2;white-space: pre; font-size: 20px">
        <p >热点要闻21:  </p>
      </div>
      <div class="scroll-text1" v-for="(item, i) in scrollText" :key="i">
        <span class="text-line1 w-[100%] inline-block" style="background-color: #b0d1ff;border-radius:15px;margin-left:100px"> {{ item.chineseTitle }}</span>
      </div>
    </div>
  </div>
</template>
 <script>
import {getNewsList} from "@/api/api";

export default {
  data() {
    return {
      scrollText: [],
    };
  },
  props: {
    // 轮播图路径数组
    type: {
      type: Array,
      default: function () {
        return "1";
      },
    },
  },
  created() {
    this.getSyLbNewList();
  },
  methods: {
    getSyLbNewList () {
      var formData = {};
      formData["pageNum"] = 1;
      formData["pageSize"] = 10;
      formData["newest"] = 2;
      formData["whetherPublish"]='1';

      getNewsList(formData).then((response) => {
        this.scrollText = response.rows;
      });
    }
  }

};
</script>
<style>
.scroll1 {
  padding: 10px 0;
}
.scroll-text-container1 {
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
}
i {
  color: burlywood;
  font-size: 14px;
  z-index: 999;
  flex: 1;
}
.scroll-text1 {
  display: inline-block;
  animation: scroll-left 10s linear infinite;
  margin-left: 50px;
}

@keyframes scroll-left {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}
</style>